<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    light
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-layout class="fill-height" tag="v-list" column>
      <v-list-tile avatar>
        <v-list-tile-avatar color="white">
          <v-img :src="logo" fill />
        </v-list-tile-avatar>
        <v-list-tile-title class="title">
          {{ config.app_name }}
        </v-list-tile-title>
      </v-list-tile>
      <v-divider />
      <v-list-tile
        v-for="(link, i) in filteredLinks"
        v-if="!link.subLinks"
        :key="i"
        :to="link.to"
        :active-class="color"
        avatar
        class="v-list-item"
      >
        <v-list-tile-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
      <v-list-group
        no-action
        value="true"
        :group="link.text"
        header="list"
        v-else
      >
        <v-list-tile slot="activator" class="v-list-item">
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('menus.' + link.text) }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="subLink in link.subLinks"
          :key="subLink.text"
          link
          :to="subLink.to"
          avatar
          class="v-list-item"
        >
          <v-list-tile-title v-text="subLink.text"></v-list-tile-title>
          <v-list-tile-action>
            <v-icon v-text="link.icon"></v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>
    </v-layout>
  </v-navigation-drawer>
</template>
<style type="text/css" scoped>
.v-list {
  overflow: scroll !important;
}
.v-list::-webkit-scrollbar {
  display: none;
}
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
}
</style>
<script>
// Utilities
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    logo: '/icon.png',
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/orders',
        icon: 'mdi-cart',
        text: 'Orders',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/categories',
        icon: 'mdi-sitemap',
        text: 'Categories',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/products',
        icon: 'mdi-view-list',
        text: 'Products',
        access: ['admin', 'superadmin'],
      },
      // {
      //   to: '/reports',
      //   icon: 'mdi-chart-line',
      //   text: 'Reports',
      //   access: ['admin', 'superadmin'],
      // },
      {
        to: '/collections',
        icon: 'mdi-archive',
        text: 'Collections',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/coupons',
        icon: 'mdi-ticket-percent',
        text: 'Coupons',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/promotions',
        icon: 'mdi-bullhorn',
        text: 'Promotions',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/banners',
        icon: 'mdi-panorama',
        text: 'Banners',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/slider',
        icon: 'mdi-image-area',
        text: 'Slider',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/admins',
        icon: 'mdi-crown',
        text: 'Admins',
        access: ['admin', 'superadmin'],
      },
      // {
      //   to: '/executives',
      //   icon: 'mdi-motorbike',
      //   text: 'Delivery Executives',
      //   access: ['admin', 'superadmin'],
      // },
      {
        to: '/settings',
        icon: 'mdi-settings',
        text: 'Settings',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/settings/shipping',
        icon: 'mdi-settings',
        text: 'Shipping Settings',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/settings/policies',
        icon: 'mdi-settings',
        text: 'Policies Settings',
        access: ['admin', 'superadmin'],
      },
      {
        to: '/vendors',
        icon: 'mdi-store',
        text: 'Vendors',
        access: ['superadmin'],
      },
      {
        to: '/paymentconfig',
        icon: 'mdi-store',
        text: 'Payment Config',
        access: ['superadmin'],
      },
    ],
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    ...mapGetters(['config']),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    accessLevel() {
      console.log(this.$store.state.user.data);
      if (this.$store.state.user.data.vid == 'all') return 'superadmin';
      else return 'admin';
    },
    items() {
      return this.$t('Layout.View.items');
    },
    filteredLinks() {
      return this.links.filter(l => l.access.includes(this.accessLevel));
    },
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
  },
};
</script>
